<template>
    <v-dialog
        v-bind="$attrs"
        :value="value"
        transition="dialog-top-transition"
        width="500"
        @input="$emit('input', $event)"
    >
        <v-card>
            <v-card-title class="text-h5">Enter Password to Verify Results</v-card-title>

            <v-card-text>
                <v-alert v-if="verifyPasswordWasIncorrect" type="error" class="mb-8" dismissible>
                    The password entered was incorrect. Please try again.
                </v-alert>

                <p>If you are unsure of the password, please consult the head table in order to be granted access.</p>

                <v-text-field
                    v-model="verifyResultsPassword"
                    label="Password"
                    type="password"
                    outlined
                    dense
                    @keyup.enter="verifyResults"
                />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="grey lighten-1" text @click.stop="closeDialog"> Cancel </v-btn>
                <v-btn
                    :color="verifyPasswordWasIncorrect ? 'red lighten-2' : 'primary lighten-2'"
                    text
                    @click="verifyResults"
                >
                    Verify Results
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        meetId: {
            type: Number,
            required: true,
        },
        value: {
            type: Boolean,
            required: true,
        },
    },

    emits: ['input', 'verified'],

    data: () => ({
        verifyResultsPassword: '',
        verifyPasswordWasIncorrect: false,
    }),

    methods: {
        closeDialog() {
            this.$emit('input', false);
        },

        async verifyResults() {
            this.verifyPasswordWasIncorrect = false;

            try {
                await axios.post('/api/verify-meet-token', {
                    meet_id: this.meetId,
                    token: this.verifyResultsPassword,
                });

                this.$store.commit('ADD_VERIFIABLE_MEET_ID', this.meetId);

                this.$emit('verified');

                this.closeDialog();
            } catch (e) {
                this.verifyPasswordWasIncorrect = true;
            }
        },
    },
};
</script>
